<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Paket</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="paket name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Paket"
        />
        <span class="text-danger text-sm">{{ errors.first("paket name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Perbandingan Harga Naik</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="up comparison"
          class="w-full sidebar-input"
          v-model="formData.up_comparison"
          placeholder="Isi Dengan Perbandingan Harga Naik"
        />
        <span class="text-danger text-sm">{{ errors.first("up comparison") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Perbandingan Harga Turun</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="down comparison"
          class="w-full sidebar-input"
          v-model="formData.down_comparison"
          placeholder="Isi Dengan Perbandingan Harga Turun"
        />
        <span class="text-danger text-sm">{{ errors.first("down comparison") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Harga Tambahan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="additional price"
          class="w-full sidebar-input"
          v-model="formData.addition_price"
          placeholder="Isi Dengan Harga Tambahan"
        />
        <span class="text-danger text-sm">{{ errors.first("additional price") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      formData: {
        name: "",
        up_comparison: null,
        down_comparison: null,
        addition_price: null,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Range Harga PPOB" : "Tambah Range Harga PPOB";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.up_comparison !== null &&
        this.formData.down_comparison !== null &&
        this.formData.addition_price !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.up_comparison = this.passData.up_comparison;
        this.formData.down_comparison = this.passData.down_comparison;
        this.formData.addition_price = this.passData.addition_price;
      } else {
        this.formData.name = "";
        this.formData.up_comparison = null;
        this.formData.down_comparison = null;
        this.formData.addition_price = null;
      }
    },
  },
  methods: {
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      const formolir = {
        name: this.formData.name,
        down_comparison: Number.parseFloat(this.formData.down_comparison),
        up_comparison: Number.parseFloat(this.formData.up_comparison),
        addition_price: Number.parseFloat(this.formData.addition_price),
      };
      this.$store
        .dispatch("ppob/cudSetRangeHarga", [{ ...formolir, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Range Harga PPOB Sukses!"
                : "Tambah Range Harga PPOB Sukses!",
            text:
              this.passData !== null
                ? `Range Harga PPOB ${v.name} Berhasil diedit`
                : `Range Harga PPOB ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.formData.name = "";
          this.formData.comparison_price = null;
          this.formData.addition_price = null;
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
};
</script>
